var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "div",
            { staticClass: "flex justify-end mb-1 mt-1 gap-2" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: {
                    click: function($event) {
                      _vm.showNewsletterPopup = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("action.add")))]
              )
            ],
            1
          ),
          _c("div", { staticClass: "compact-list" }, [
            _c("div", { staticClass: "list-header" }, [
              _c("span", { staticClass: "list-counter" }, [
                _vm._v("(" + _vm._s(_vm.timelines.length) + " registros)")
              ])
            ]),
            _c(
              "div",
              { staticClass: "list-items" },
              _vm._l(_vm.timelines, function(item, index) {
                return _c("div", { key: item.id, staticClass: "list-item" }, [
                  _c("div", { staticClass: "item-content" }, [
                    _c("div", { staticClass: "item-counter" }, [
                      _vm._v(_vm._s(index + 1))
                    ]),
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v(_vm._s(item.newsletter.title))
                    ]),
                    _c("div", { staticClass: "item-dates" }, [
                      _c("div", { staticClass: "date-field" }, [
                        _c("label", { staticClass: "date-label" }, [
                          _vm._v("Início")
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.start_at,
                              expression: "item.start_at"
                            }
                          ],
                          staticClass: "form-control date-input",
                          attrs: {
                            type: "date",
                            min: _vm.minDate,
                            max: item.end_at || undefined
                          },
                          domProps: { value: item.start_at },
                          on: {
                            change: function($event) {
                              return _vm.validateStartDate(item)
                            },
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(item, "start_at", $event.target.value)
                              },
                              _vm.checkCanSave
                            ]
                          }
                        })
                      ]),
                      _c("div", { staticClass: "date-field" }, [
                        _c("label", { staticClass: "date-label" }, [
                          _vm._v("Fim")
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.end_at,
                              expression: "item.end_at"
                            }
                          ],
                          staticClass: "form-control date-input",
                          attrs: {
                            type: "date",
                            min: item.start_at || _vm.minDate
                          },
                          domProps: { value: item.end_at },
                          on: {
                            change: function($event) {
                              return _vm.validateEndDate(item)
                            },
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(item, "end_at", $event.target.value)
                              },
                              _vm.checkCanSave
                            ]
                          }
                        })
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "item-actions" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            attrs: {
                              variant: "outline-info",
                              size: "sm",
                              title: _vm.$t(
                                "newsletter.workflow.checkpoint.title"
                              ),
                              disabled: !_vm.canManageCheckpoints(item)
                            },
                            on: {
                              click: function($event) {
                                return _vm.openCheckpointPopup(item)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "feather icon-check-circle"
                            })
                          ]
                        ),
                        _c(
                          "vs-dropdown",
                          {
                            staticClass: "cursor-pointer ml1 dropdown-aligned",
                            attrs: {
                              "vs-custom-content": "",
                              "vs-trigger-click": ""
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass:
                                "h-5 w-5 stroke-current dropdown-icon",
                              attrs: {
                                type: "filled",
                                icon: "MoreVerticalIcon"
                              }
                            }),
                            _c(
                              "vs-dropdown-menu",
                              [
                                _c("vs-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex dropdown-remove-item",
                                      staticStyle: { width: "150px" },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmRemoveItem(item)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-2/12" },
                                        [
                                          _c("feather-icon", {
                                            attrs: {
                                              icon: "TrashIcon",
                                              svgClasses:
                                                "h-5 w-5 mb-1 stroke-current text-danger"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "w-10/12" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex text-danger font-medium"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("action.remove")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              }),
              0
            )
          ]),
          _c(
            "div",
            { staticClass: "flex justify-end mb-2 mt-2 gap-2" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", disabled: !_vm.canSaveTimeline },
                  on: { click: _vm.saveTimeline }
                },
                [_vm._v(_vm._s(_vm.$t("action.save")))]
              ),
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.goBack }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "CornerUpLeftIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("back")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("newsletter-popup", {
            on: { "selected-items": _vm.selectedItems },
            model: {
              value: _vm.showNewsletterPopup,
              callback: function($$v) {
                _vm.showNewsletterPopup = $$v
              },
              expression: "showNewsletterPopup"
            }
          }),
          _c(
            "b-modal",
            {
              attrs: {
                id: "checkpoint-modal",
                title: _vm.$t("newsletter.workflow.checkpoint.title"),
                size: "md",
                "ok-only": true,
                "ok-title": _vm.$t("action.ok")
              },
              on: {
                ok: _vm.saveCheckpointDates,
                cancel: _vm.closeCheckpointPopup,
                hide: _vm.closeCheckpointPopup
              },
              model: {
                value: _vm.showCheckpointPopup,
                callback: function($$v) {
                  _vm.showCheckpointPopup = $$v
                },
                expression: "showCheckpointPopup"
              }
            },
            [
              _vm.currentTimelineItem
                ? _c("div", [
                    _c("div", { staticClass: "mb-3" }, [
                      _c("h6", { staticClass: "text-primary" }, [
                        _vm._v(_vm._s(_vm.currentTimelineItem.newsletter.title))
                      ]),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("newsletter.workflow.checkpoint.description")
                          )
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "timeline-period mb-3" }, [
                      _c("div", { staticClass: "period-info" }, [
                        _c("i", {
                          staticClass: "feather icon-calendar text-info"
                        }),
                        _c("span", { staticClass: "period-label" }, [
                          _vm._v("Período do cronograma:")
                        ]),
                        _c("span", { staticClass: "period-dates" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDateDisplay(
                                  _vm.currentTimelineItem.start_at
                                )
                              )
                            )
                          ]),
                          _c("span", { staticClass: "period-separator" }, [
                            _vm._v("até")
                          ]),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDateDisplay(
                                  _vm.currentTimelineItem.end_at
                                )
                              )
                            )
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "period-note" }, [
                        _c("small", { staticClass: "text-muted" }, [
                          _c("i", { staticClass: "feather icon-info" }),
                          _vm._v(
                            " As datas de verificação devem estar dentro deste período "
                          )
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "checkpoint-list" },
                      [
                        _vm._l(_vm.checkpointDates, function(
                          checkpoint,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index, staticClass: "checkpoint-item" },
                            [
                              _c("div", { staticClass: "checkpoint-date" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: checkpoint.date,
                                      expression: "checkpoint.date"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "date",
                                    min:
                                      _vm.currentTimelineItem.start_at ||
                                      _vm.minDate,
                                    max: _vm.currentTimelineItem.end_at
                                  },
                                  domProps: { value: checkpoint.date },
                                  on: {
                                    change: function($event) {
                                      return _vm.validateCheckpointDate(
                                        checkpoint,
                                        index
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        checkpoint,
                                        "date",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _c(
                                "div",
                                { staticClass: "checkpoint-actions" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "outline-danger",
                                        size: "sm",
                                        title: _vm.$t("action.remove")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeCheckpoint(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "feather icon-trash-2"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        _vm.checkpointDates.length === 0
                          ? _c("div", { staticClass: "no-checkpoints" }, [
                              _c(
                                "p",
                                { staticClass: "text-muted text-center" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "newsletter.workflow.checkpoint.no_dates"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "mt-1 float-right gap-2 " },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-primary", size: "sm" },
                            on: { click: _vm.addNewCheckpoint }
                          },
                          [
                            _c("i", { staticClass: "feather icon-plus" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "newsletter.workflow.checkpoint.add_date"
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }